export const EMAIL_PATTERN = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$';
export const PHONE_PATTERN = '^\\(\\d{3}\\)\\s\\d{3}-\\d{4}$';
